import { render, staticRenderFns } from "./search_page.vue?vue&type=template&id=488db1fd&scoped=true"
import script from "./search_page.vue?vue&type=script&lang=ts"
export * from "./search_page.vue?vue&type=script&lang=ts"
import style0 from "./search_page.vue?vue&type=style&index=0&id=488db1fd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488db1fd",
  null
  
)

export default component.exports